import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SettingsState {
  selectedAgencyId: number | undefined;
  selectedClientId: number | undefined;
}

// Persisted initial state from localStorage to survive page refresh
const getPersistedNumber = (key: string): number | undefined => {
  try {
    if (typeof window === "undefined") return undefined;
    const raw = localStorage.getItem(key);
    if (raw === null || raw === "" || raw === "undefined") return undefined;
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? undefined : parsed;
  } catch {
    return undefined;
  }
};

const initialState: SettingsState = {
  selectedAgencyId: getPersistedNumber("selectedAgencyId"),
  selectedClientId: getPersistedNumber("selectedClientId")
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSelectedAgency: (state, action: PayloadAction<number | undefined>) => {
      state.selectedAgencyId = action.payload;
      try {
        if (typeof window !== "undefined") {
          if (action.payload !== undefined && action.payload !== null) {
            localStorage.setItem("selectedAgencyId", String(action.payload));
          } else {
            localStorage.removeItem("selectedAgencyId");
          }
        }
      } catch {}
    },
    setSelectedClient: (state, action: PayloadAction<number | undefined>) => {
      state.selectedClientId = action.payload;
      try {
        if (typeof window !== "undefined") {
          if (action.payload !== undefined && action.payload !== null) {
            localStorage.setItem("selectedClientId", String(action.payload));
          } else {
            localStorage.removeItem("selectedClientId");
          }
        }
      } catch {}
    },
    clearSelectedCompanies: (state) => {
      state.selectedAgencyId = undefined;
      state.selectedClientId = undefined;
      try {
        if (typeof window !== "undefined") {
          localStorage.removeItem("selectedAgencyId");
          localStorage.removeItem("selectedClientId");
        }
      } catch {}
    }
  }
});

export const { setSelectedAgency, setSelectedClient, clearSelectedCompanies } = settingsSlice.actions;
export default settingsSlice.reducer; 